var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhiteRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#white-rounded_svg__clip0_1210_18327)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20zm6.997-7.98H22.82V11.266h-1.865c-3.419 0-5.215 1.727-5.215 4.282 0 2.9 1.244 4.248 3.799 5.974l2.107 1.416-6.078 9.082h-4.524l5.456-8.115c-3.142-2.245-4.903-4.42-4.903-8.115 0-4.627 3.211-7.77 9.323-7.77h6.078v24z",
  fill: "#000"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "white-rounded_svg__clip0_1210_18327"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#fff"
})))));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEyMTBfMTgzMjcpIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjAgNDBDMzEuMDQ1OSA0MCA0MCAzMS4wNDU2IDQwIDIwQzQwIDguOTU0MzcgMzEuMDQ1OSAwIDIwIDBDOC45NTQxNiAwIDAgOC45NTQzNyAwIDIwQzAgMzEuMDQ1NiA4Ljk1NDE2IDQwIDIwIDQwWk0yNi45OTcxIDMyLjAySDIyLjgxODZWMTEuMjY2MUgyMC45NTRDMTcuNTM1MSAxMS4yNjYxIDE1LjczOTUgMTIuOTkyNyAxNS43Mzk1IDE1LjU0ODFDMTUuNzM5NSAxOC40NDg3IDE2Ljk4MjcgMTkuNzk1NSAxOS41MzggMjEuNTIyMUwyMS42NDQ2IDIyLjkzOEwxNS41NjY3IDMyLjAySDExLjA0MzFMMTYuNDk5NCAyMy45MDQ5QzEzLjM1NjYgMjEuNjYwMiAxMS41OTU1IDE5LjQ4NDcgMTEuNTk1NSAxNS43ODk3QzExLjU5NTUgMTEuMTYyNSAxNC44MDcxIDguMDIgMjAuOTE5NSA4LjAySDI2Ljk5NzFWMzIuMDJaIiBmaWxsPSJibGFjayIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEyMTBfMTgzMjciPgo8cmVjdCB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHJ4PSIyMCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgWhiteRounded as ReactComponent };